export default {"src":"/_next/static/media/logo.336f76ec.svg","height":60,"width":140,"blurWidth":0,"blurHeight":0};